module.exports = __webpack_public_path__ + "img/yingyong.d6384d99.png";